import LeftBehind from '@/views/LeftBehind'
import Quality from '@/views/Quality'
import MeshQuality from "@/views/MeshQuality.vue";
import Reliability from '@/views/Reliability'
import Vue from 'vue'
import Router from 'vue-router'
import {ModeEnum} from "@/utils/consts";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: ModeEnum.RELIABILITY,
      component: Reliability
    },
    {
      path: '/qualite',
      name: ModeEnum.QUALITY,
      component: Quality
    },
    {
      path: '/qualite-maillage',
      name: ModeEnum.MESH_QUALITY,
      component: MeshQuality
    },
    {
      path: '/reste-a-quai',
      name: ModeEnum.LEFTBEHIND,
      component: LeftBehind
    }
  ]
})
